import { render, staticRenderFns } from "./RemoteSensingMall.vue?vue&type=template&id=7c54ed48&scoped=true&"
import script from "./RemoteSensingMall.vue?vue&type=script&lang=js&"
export * from "./RemoteSensingMall.vue?vue&type=script&lang=js&"
import style0 from "./RemoteSensingMall.vue?vue&type=style&index=0&id=7c54ed48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c54ed48",
  null
  
)

export default component.exports